import axiosInstance from "../../utils/axiosInstance";
import {
  setTraining,
  setTrainings,
  setLoading,
  setLoadingId,
} from "../../store/slices/training";
import { AppDispatch } from "../../store/store";
import { isAxiosError } from "axios";
import { notify } from "../../components/alerts";
import { ITraining } from "../../store/@types/training";

const trainingEndpoint = "/training/api/v1/trainings";

type ITrainingDetailResponse = {
  success: boolean;
  message: string;
  data: ITraining;
};

export const get_trainings = async (
  dispatch: AppDispatch,
  limit: number,
  offset: number,
) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get(`${trainingEndpoint}`, {
      params: { limit, offset },
    });
    dispatch(setTrainings(response.data));
  } catch (err) {
    if (isAxiosError(err)) {
      console.log(err.response?.data.message || "Failed to load trainings");
      notify({
        type: "error",
        message: err.response?.data?.message || "Failed to load trainings",
      });
    }
  } finally {
    dispatch(setLoading(false));
  }
};

export const get_training = async (dispatch: AppDispatch, id: string) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get<ITrainingDetailResponse>(
      `${trainingEndpoint}/${id}`,
    );
    dispatch(setTraining(response.data.data));
  } catch (err) {
    if (isAxiosError(err)) {
      console.log(err.response?.data.message || "Failed to load training");
      notify({
        type: "error",
        message: err.response?.data?.message || "Failed to load training",
      });
    }
  } finally {
    dispatch(setLoading(false));
  }
};

export const enroll_training = async (
  id: string,
  email: string,
  dispatch: AppDispatch,
) => {
  dispatch(setLoadingId(id));
  try {
    const response = await axiosInstance.post(
      `${trainingEndpoint}/${id}/enroll`,
      { email },
    );

    notify({
      type: "success",
      message: response.data.message || "Enrollment successful",
    });
  } catch (err) {
    if (isAxiosError(err)) {
      notify({
        type: "error",
        message: err.response?.data?.message || "Failed to enroll",
      });
    }
  } finally {
    dispatch(setLoadingId(null));
  }
};
